"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation deletePlatformFee($feeId: String!) {
    deletePlatformFee(feeId: $feeId)
  }
`;
exports.default = mutation;
//# sourceMappingURL=deletePlatformFee.mutation.js.map